import { useTranslation } from 'react-i18next';

interface TooltipConditions {
  ramWarningBarToggle?: boolean;
  isMDSUpAndRunning?: boolean;
  restaurantId?: string;
  isRestaurantClosed?: boolean;
}

export const useGeneralTooltip = (conditions: TooltipConditions): string => {
  const { t } = useTranslation();
  const {
    ramWarningBarToggle,
    isMDSUpAndRunning,
    restaurantId,
    isRestaurantClosed,
  } = conditions;

  if (!isMDSUpAndRunning && ramWarningBarToggle)
    return t('operationHours.plannedMaintenance');
  if (!isMDSUpAndRunning) return t('operationHours.unplannedMaintenance');
  if (restaurantId && isRestaurantClosed)
    return t('operationHours.restaurantClosedMessage');
  return '';
};
